import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  MenuItem,
  TextField,
} from "@mui/material";
import React from "react";
import { ActivityLogContext } from "../context/activityLogContext";
import { ALL_AREAS, RoleFilterKey } from "../interface/iActivityLogFilter";
import { ActivityLogStatus } from "../interface/iActivityLogEntry";
import { AREA_LABELS } from "../functions/activityLogLabels";

const ROLE_OPTIONS: { key: RoleFilterKey; label: string }[] = [
  { key: "TN", label: "TN" },
  { key: "Coach", label: "Coach" },
  { key: "Admin", label: "Admin" },
  { key: "System", label: "System" },
  { key: "unknown", label: "Unbekannt" },
];

const STATUS_OPTIONS: { value: "all" | ActivityLogStatus; label: string }[] = [
  { value: "all", label: "Alle" },
  { value: "success", label: "Erfolgreich" },
  { value: "failed", label: "Fehlgeschlagen" },
];

const ActivityLogFilters = (): React.JSX.Element => {
  const { filter, updateFilter } = React.useContext(ActivityLogContext);

  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        gridTemplateColumns: { xs: "1fr", md: "2fr 1fr 1fr 2fr" },
        alignItems: "center",
        mb: 3,
      }}
    >
      <FormControl component="fieldset">
        <FormLabel component="legend">Rolle</FormLabel>
        <FormGroup row>
          {ROLE_OPTIONS.map((role) => (
            <FormControlLabel
              key={role.key}
              label={role.label}
              control={
                <Checkbox
                  checked={filter.roles[role.key]}
                  onChange={(event) =>
                    updateFilter({
                      roles: { ...filter.roles, [role.key]: event.target.checked },
                    })
                  }
                />
              }
            />
          ))}
        </FormGroup>
      </FormControl>

      <TextField
        id="activity-log-area"
        select
        label="Bereich"
        value={filter.area}
        onChange={(event) => updateFilter({ area: event.target.value })}
      >
        <MenuItem value={ALL_AREAS}>Alle</MenuItem>
        {Object.entries(AREA_LABELS).map(([key, label]) => (
          <MenuItem key={key} value={key}>
            {label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        id="activity-log-status"
        select
        label="Status"
        value={filter.status}
        onChange={(event) =>
          updateFilter({ status: event.target.value as "all" | ActivityLogStatus })
        }
      >
        {STATUS_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        id="activity-log-search"
        label="Suche"
        placeholder="Name, E-Mail oder Meldung"
        value={filter.search}
        onChange={(event) => updateFilter({ search: event.target.value })}
      />
    </Box>
  );
};

export default ActivityLogFilters;
